import { get, post } from './request'
import { utilities } from '@billow/js-helpers'

export let paginate = (path, success, failure) => {
  return get(
    `api${path}`, success, failure
  )
}

export let load = (screening, success, failure) => get(
  `api/cinema/screening/${screening}`, success, failure
)

export let create = (screening, success, failure) => post(
  `api/cinema/screening/create`, screening, success, failure
)

export let save = (screening, success, failure) => post(
  `api/cinema/screening/${screening.id}/update`, screening, success, failure
)

export let saveFile = (payload, success, failure) => {

  return post(
    `api/cinema/screening/${payload.screeningId}/file/update`,
    utilities.formData(payload),
    success,
    failure
  )
}

export let remove = (screening, success, failure) => post(
  `api/cinema/screening/${screening}/remove`, {}, success, failure
)